async function userRequest(path, options = {}) {
  const response = await fetch(`/api${path}`, {
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    ...options
  });

  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(data.error || 'Error de red');
    error.status = response.status;
    throw error;
  }
  return data;
}

export function getMe() {
  return userRequest('/auth/me');
}

export function register(data) {
  return userRequest('/auth/register', { method: 'POST', body: JSON.stringify(data) });
}

export function login(email, password) {
  return userRequest('/auth/login', { method: 'POST', body: JSON.stringify({ email, password }) });
}

export function googleLogin(credential) {
  return userRequest('/auth/google', { method: 'POST', body: JSON.stringify({ credential }) });
}

export function logout() {
  return userRequest('/auth/logout', { method: 'POST' });
}

export function listComments(contentType, contentId) {
  return userRequest(`/comments?contentType=${contentType}&contentId=${contentId}`);
}

export function postComment(contentType, contentId, body) {
  return userRequest('/comments', { method: 'POST', body: JSON.stringify({ contentType, contentId, body }) });
}
